export default __webpack_public_path__ + "static/media/team61.781991f4.JPG";